/**
 * Escape guard for inline editors inside Radix Sheets/Dialogs.
 *
 * Radix's useEscapeKeydown listens on `document` in the CAPTURE phase, so a
 * React onKeyDown handler can never stop Escape from dismissing the parent
 * sheet. Inline editors register here while open, and the sheet checks the
 * flag in `onEscapeKeyDown` and calls preventDefault().
 */
let openEditors = 0;

export const beginEscapeGuard = () => { openEditors += 1; };
export const endEscapeGuard = () => { openEditors = Math.max(0, openEditors - 1); };
export const isEscapeGuarded = () => openEditors > 0;

/** Drop-in handler for Radix `onEscapeKeyDown`. */
export const guardEscapeKeyDown = (e) => { if (isEscapeGuarded()) e.preventDefault(); };
